import React from 'react';

import { Filter } from '@gogame/filters';

import {
  FILTER_AGENCIES,
  FILTER_MASTER_CAMPAIGNS,
  FILTER_INFLUENCERS,
  FILTER_CATEGORIES,
  FILTER_SUB_CATEGORIES,
  FILTER_SOCIAL_MEDIA_PLATFORMS,
  FILTER_COUNTRIES,
  FILTER_APPLICATIONS,
  FILTERS_DEPENDENCIES as DEPENDENCIES,
} from 'scenes/Influencers/InfluencersChannels/constants';
import * as filtersSource from 'scenes/Influencers/InfluencersChannels/sources/filters';

export const Agencies = (props) => {
  return (
    <Filter.MultiSelect
      title={'Agencies'}
      name={FILTER_AGENCIES}
      source={filtersSource.loadAgencies}
      depends={DEPENDENCIES[FILTER_AGENCIES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const MasterCampaigns = (props) => {
  return (
    <Filter.MultiSelect
      title={'Master Campaigns'}
      name={FILTER_MASTER_CAMPAIGNS}
      source={filtersSource.loadMasterCampaigns}
      depends={DEPENDENCIES[FILTER_MASTER_CAMPAIGNS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Influencers = (props) => {
  return (
    <Filter.MultiSelect
      title={'Influencers'}
      name={FILTER_INFLUENCERS}
      source={filtersSource.loadInfluencers}
      depends={DEPENDENCIES[FILTER_INFLUENCERS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Categories = (props) => {
  return (
    <Filter.MultiSelect
      title={'Categories'}
      name={FILTER_CATEGORIES}
      source={filtersSource.loadCategories}
      depends={DEPENDENCIES[FILTER_CATEGORIES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const SubCategories = (props) => {
  return (
    <Filter.MultiSelect
      title={'Subcategories'}
      name={FILTER_SUB_CATEGORIES}
      source={filtersSource.loadSubCategories}
      depends={DEPENDENCIES[FILTER_SUB_CATEGORIES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const SocialMediaPlatforms = (props) => {
  return (
    <Filter.MultiSelect
      title={'Social Media Platforms'}
      name={FILTER_SOCIAL_MEDIA_PLATFORMS}
      source={filtersSource.loadSocialMediaPlatforms}
      depends={DEPENDENCIES[FILTER_SOCIAL_MEDIA_PLATFORMS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Countries = (props) => {
  return (
    <Filter.MultiSelect
      title={'Countries'}
      name={FILTER_COUNTRIES}
      source={filtersSource.loadCountries}
      depends={DEPENDENCIES[FILTER_COUNTRIES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Applications = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={filtersSource.loadApplications}
      depends={DEPENDENCIES[FILTER_APPLICATIONS]}
      placeholder={'All'}
      {...props}
    />
  );
};
